import { render } from "./WorkerFormsM.vue?vue&type=template&id=0c5e6e60&scoped=true"
import script from "./WorkerFormsM.vue?vue&type=script&lang=js"
export * from "./WorkerFormsM.vue?vue&type=script&lang=js"

import "./WorkerFormsM.vue?vue&type=style&index=0&id=0c5e6e60&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5e6e60"]])

export default __exports__